import m from "../../geodata/es2015/usaAlbersLow";
window.am4geodata_usaAlbersLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/usaAlbersLow.js
// module id = null
// module chunks = 